const publicAuthActionPaths = new Set([
  '/',
  '/preview',
  '/features',
  '/use-cases',
  '/plans',
  '/cookie-policy',
  '/cookie-policy.html',
  '/privacy-policy',
  '/privacy-policy.html',
  '/terms-of-service',
  '/terms-of-service.html',
  '/acceptable-use-policy',
  '/acceptable-use-policy.html',
  '/privacy-requests',
  '/pocket-phrasebook/privacy',
  '/pocket-phrasebook/support',
]);

export const shouldShowPublicAuthActions = (
  activePath: string,
  isEntryAuthFlow: boolean,
): boolean => {
  if (isEntryAuthFlow) return false;
  if (activePath.startsWith('/use-cases/')) return true;
  return publicAuthActionPaths.has(activePath);
};

export const isPublicNavLinkActive = (activePath: string, targetPath: string): boolean =>
  activePath === targetPath || activePath.startsWith(`${targetPath}/`);
